import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { from, Observable, of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";

import { ApiUtilitiesService } from "./apiUtilitiesService.g";

@Injectable()
export class GoogleMapsApiKeyLoaderService
{
    private httpClient = inject(HttpClient);
    private readonly $apiUtilitiesService = inject(ApiUtilitiesService);


    IsLoaded(drawing?: boolean): Observable<boolean>
    {
        const drawingScript = drawing ? "&libraries=drawing" : "";
        return from(this.$apiUtilitiesService.GetGoogleMapsApiKey()).pipe(
            mergeMap(apiKey =>
            {
                if (!apiKey)
                    return of(false);
                return this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${apiKey}${drawingScript}`, "callback")
                    .pipe(map(() => true), catchError(() => of(false)));
            }),
            catchError(() => of(false))
);
    }
}
